webpackJsonp([131205106617749],{

/***/ 3005:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/crunches"},"frontmatter":{"title":"Crunches","date":null}}}]}},"pathContext":{"tag":"crunches"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-crunches-a251a3d93bde0ea4e0e9.js